import React, { useContext, useEffect, useState } from "react";
import Card from "../../../../../components/Card";
import styles from "./Market.module.sass";
import cn from "classnames";
import Row from "./Row";
import { GlobalState } from '../../../../../App'
import Form from "../../../../../components/Form";

const Market = () => {

  const { activeVariationAttr,
    variationsList, setIsClickActionComplete, isClickedSave, setIsClickedSave,
    setShowPopup, attributeList, attrColor, setAttrColor,
    attrSize, setAttrSize } = useContext(GlobalState)

  const [searchColor, setSearchColor] = useState('')
  const [searchAttr, setSearchAttr] = useState('')

  useEffect(() => {
    if (activeVariationAttr) {
      for (let index = 0; index < activeVariationAttr.attrList.length; index++) {
        if (activeVariationAttr.attrList[index]?.data?.type === "Color") {
          setAttrColor(activeVariationAttr.attrList[index])
        }

        if (activeVariationAttr.attrList[index]?.data?.type === "Size") {
          setAttrSize(activeVariationAttr.attrList[index])
        }

      }
    }
  }, [activeVariationAttr])

  const [colorItemsList, setColorItemsList] = useState()
  const [sizeItemsList, setSizeItemsList] = useState()

  useEffect(() => {
    setColorItemsList(attributeList.filter(data => data?.data?.type === 'Color'))
    setSizeItemsList(attributeList.filter(data => data?.data?.type === 'Size'))
  }, [attributeList])

  useEffect(() => {

  }, [colorItemsList, sizeItemsList])

  useEffect(() => {

    if (isClickedSave) {
      for (var i = 0; i < variationsList.length; i++) {

        if (variationsList[i]?.id === activeVariationAttr?.id) {

          variationsList[i]['attributes'] = []

          if (attrColor?.id !== undefined) {
            variationsList[i]?.attributes.push(attrColor)
            setAttrColor()
          }
          if (attrSize?.id !== undefined) {
            variationsList[i]?.attributes.push(attrSize)
            setAttrSize()
          }
          setIsClickedSave(false)
          setIsClickActionComplete(true)
          setShowPopup(false)
        }
      }

    }

  }, [isClickedSave])

  return (
    <>
      <Card
        className={cn(styles.card, styles.colorsCard)}
        title="Color"
        classTitle={styles.cardTitle}
        classCardHead={styles.cardHead}
        head={
          <Form
            className={styles.form}
            value={searchColor}
            setValue={setSearchColor}
            placeholder="Search by label"
            type="text"
            name="search"
            iconSize={15}
            icon="search"
          />
        }
      >
        <div className={styles.market}>
          <div className={styles.table}>
            <div className={styles.row}>
              <div className={styles.col}>Select</div>
              <div className={styles.col}>Label</div>
              <div className={styles.col}>Value</div>
            </div>

            {colorItemsList
              ?.filter(data => {
                if (searchColor !== '') {
                  if (data?.data?.label.toLowerCase().includes(searchColor.toLowerCase())) {
                    return data
                  }
                } else {
                  return data
                }
              })
              .map((x, index) => (
                <Row
                  item={x.data}
                  key={index}
                  up={attributeList.length - index <= 2}
                  onChange={() => {
                    setAttrColor(x)
                  }}
                  serachBy={searchColor}
                  value={
                    x?.data?.id === attrColor?.id
                  }
                  name="Color"
                />
              ))}

          </div>

        </div>
      </Card>

      <Card
        className={cn(styles.card)}
        title="Size"
        classCardHead={styles.cardHead}
        head={
          <Form
            className={styles.form}
            value={searchAttr}
            setValue={setSearchAttr}
            placeholder="Search by label"
            type="text"
            name="search"
            iconSize={15}
            icon="search"
          />
        }
      >
        <div className={styles.market}>
          <div className={styles.table}>
            <div className={styles.row}>
              <div className={styles.col}>Select</div>
              <div className={styles.col}>Label</div>
              <div className={styles.col}>Value</div>
            </div>
            {sizeItemsList
              ?.filter(data => {
                if (searchAttr !== '') {
                  if (data?.data?.label?.toLowerCase().includes(searchAttr.toLowerCase())) {
                    return data
                  }
                } else {
                  return data
                }
              })
              .map((x, index) => (
                <Row
                  item={x?.data}
                  key={index}
                  up={attributeList.length - index <= 2}
                  value={
                    x?.data?.id === attrSize?.id
                  }
                  serachBy={searchAttr}
                  onChange={() => {
                    setAttrSize(x)
                  }
                  }
                  name="Size"
                />
              ))}
          </div>

        </div>
      </Card>
    </>
  );
};

export default Market;
